// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IEmployeePlanTaxYearRequest } from './IEmployeePlanTaxYearRequest';
import {
    IEmployeePlanTaxYearRequestFromJSON,
    IEmployeePlanTaxYearRequestFromJSONTyped,
    IEmployeePlanTaxYearRequestToJSON,
    IEmployeePlanTaxYearRequestToJSONTyped,
} from './IEmployeePlanTaxYearRequest';

/**
 * Request to search for IRS contribution limits
 * @export
 * @interface IIrsLimitsSearchRequest
 */
export interface IIrsLimitsSearchRequest {
    /**
     * List of employee-plan-tax year combinations to search for
     * @type {Array<IEmployeePlanTaxYearRequest>}
     * @memberof IIrsLimitsSearchRequest
     */
    requests: Array<IEmployeePlanTaxYearRequest>;
}

/**
 * Check if a given object implements the IIrsLimitsSearchRequest interface.
 */
export function instanceOfIIrsLimitsSearchRequest(value: object): value is IIrsLimitsSearchRequest {
    if (!('requests' in value) || value['requests'] === undefined) return false;
    return true;
}

export function IIrsLimitsSearchRequestFromJSON(json: any): IIrsLimitsSearchRequest {
    return IIrsLimitsSearchRequestFromJSONTyped(json, false);
}

export function IIrsLimitsSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIrsLimitsSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'requests': ((json['requests'] as Array<any>).map(IEmployeePlanTaxYearRequestFromJSON)),
    };
}

export function IIrsLimitsSearchRequestToJSON(json: any): IIrsLimitsSearchRequest {
    return IIrsLimitsSearchRequestToJSONTyped(json, false);
}

export function IIrsLimitsSearchRequestToJSONTyped(value?: IIrsLimitsSearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requests': ((value['requests'] as Array<any>).map(IEmployeePlanTaxYearRequestToJSON)),
    };
}

